import {
    USERS_PATCH_REQUEST,
    USERS_PATCH_SUCCESS,
    USERS_PATCH_FAILURE,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export const userManagementPatchReducer = (state = initialState, action) => {
    const { type } = action;
    switch (type) {
        case USERS_PATCH_SUCCESS: return { ...initialState };

        case USERS_PATCH_REQUEST: return { ...initialState, patching: true };

        case USERS_PATCH_FAILURE: return { ...initialState, hasErrors: true };

        default: return state;
    }
};
